import cloneDeep from "lodash.clonedeep";

import { ActionTypes } from "../store/actionTypes";
import AuthState from "../models/state/authState";
import Action from "../store/action";

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  error: null,
  accessToken: null,
  globalError: null,
  user: null,
};

const reducer = (
  state: AuthState | undefined = initialState,
  action: Action
) => {
  let newState = cloneDeep(state);

  switch (action.type) {
    case ActionTypes.AUTH_LOADING:
      newState.isLoading = true;
      return newState;

    case ActionTypes.AUTH_LOGIN:
      newState.isAuthenticated = true;
      newState.isLoading = false;
      return newState;

    case ActionTypes.SET_ACCESS_TOKEN:
      newState.accessToken = action.payload;
      return newState;

    case ActionTypes.SET_USER_DATA:
      newState.user = action.payload;
      return newState;

    case ActionTypes.AUTH_ERROR:
      newState.error = action.payload.error;
      newState.isLoading = false;
      return newState;

    default:
      return newState;
  }
};

export default reducer;
